import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { BidResponseWorkflowQuery } from "../../../../generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../../useGraphQlClient";

const bidResponseWorkflowQuery = graphql(`
  query bidResponseWorkflow {
    bidResponseWorkflow {
      id
      isDefault
      transitions {
        id
        group
        order
        stage {
          id
          name
          color
          iconColor
          iconName
        }
      }
    }
  }
`);

export function useBidResponseWorkflow(
  options?: UseQueryOptions<BidResponseWorkflowQuery, unknown, BidResponseWorkflowQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(["bidResponseWorkflow"], bidResponseWorkflowQuery, [], {
    ...options,
  });
  return { ...rest, data: data?.bidResponseWorkflow };
}
